import { Components, Theme } from '@mui/material';

export default {
  styleOverrides: {
    row: ({ theme }) => ({
      gap: theme.spacing(3),
    }),
  }
} as Components<Theme>['MuiFormGroup'];